'use strict';

angular.module('userRequestRoutes', ['ListAccessRequestControllers',
                                     'services.userAccessRequest',
                                     'services.authenticatedUser'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
       .state('userAccessRequest', {
           url: '/UserRequest',
           template: '<div ui-view></div>',
           controller: 'MainAccessRequestCtrl',
           resolve: {
               authenticatedUser: ['authenticatedUserService', function (service) {
                   return service.getAuthenticatedUser();
               }],
               enoughRights: ['authenticatedUser', function (authenticatedUser) {
                   return authenticatedUser.IsInAdministrationGroup ||
                          authenticatedUser.IsInITOperationsGroup ||
                          authenticatedUser.IsInBTGAccessManagementGroup ||
                          authenticatedUser.IsInITServiceDeskGroup ||
                          authenticatedUser.IsInCustodianGroup;
               }],
               custodian: ['authenticatedUser', function (authenticatedUser) {
                   if (authenticatedUser.IsInAdministrationGroup) return null;
                   if (authenticatedUser.IsInCustodianGroup) return authenticatedUser.CustodianGroup;

                   return 'BTGAccessManagementGroup'; 
               }]
           }
       })

       // Request List
       .state('userAccessRequest.request', {
           abstract: true,
           views: {
               '': {
                   templateUrl: require('./MainAccessRequest.tpl.html'),
               },
               'sidebar@userAccessRequest.request': {
                   templateUrl: require('./SideBar.tpl.html'),
                   controller: 'SideBarUserAccessRequestCtrl',
                   resolve: {
                       nbRequests: ['userAccessRequestService', function (userAccessRequestService) {
                           return userAccessRequestService.countRequests();
                       }]
                   }
               }
           }
       })

       .state('userAccessRequest.request.all', {
           url: '/manage?page&searchTerm&type',
           params: {
               page: { value: 1 },
               searchTerm: { value: '' },
               type: { value: 'all' }
           },
           views: {
               'displayRequests': {
                   templateUrl: require('./DisplayRequests.tpl.html'),
                   controller: 'DisplayRequestsController'
               }
           },
           resolve: {
               getRequests: ['userAccessRequestService', '$stateParams', function (service) {
                   return service.getAllUserRequests;
               }],
               requestStatus: function () {
                   return 'all';
               }
           }
       })
      .state('userAccessRequest.request.notStarted', {
          url: '/notStarted?page&searchTerm&type',
         params: {
             page: { value: 1 },
             searchTerm: { value: '' },
             type: { value: 'all' }
         },
         views: {
             'displayRequests': {
                 templateUrl: require('./DisplayRequests.tpl.html'),
                 controller: 'DisplayRequestsController'
             }
         },
         resolve: {
             getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                 return userAccessRequestService.getNotStartedUserRequests;
             }],
             requestStatus: function () {
                 return 'notStarted';
             }
         }
      })
      .state('userAccessRequest.request.draft', {
          url: '/draft?page&searchTerm&type',
          params: {
              page: { value: 1 },
              searchTerm: { value: '' },
              type: { value: 'all' }
          },
          views: {
              'displayRequests': {
                  templateUrl: require('./DisplayRequests.tpl.html'),
                  controller: 'DisplayRequestsController'
              }
          },
          resolve: {
              getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                  return userAccessRequestService.getDraftUserRequests;
              }],
              requestStatus: function () {
                   return 'draft';
              }
          }
      })
      .state('userAccessRequest.request.underReview', {
          url: '/underReview?page&searchTerm&type',
          params: {
              page: { value: 1 },
              searchTerm: { value: '' },
              type: { value: 'all' }
          },
          views: {
              'displayRequests': {
                  templateUrl: require('./DisplayRequests.tpl.html'),
                  controller: 'DisplayRequestsController'
              }
          },
          resolve: {
              getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                  return userAccessRequestService.getUnderReviewUserRequests;
              }],
              requestStatus: function () {
                  return 'underReview';
              }
          }
      })
      .state('userAccessRequest.request.pendingAuthorization', {
          url: '/pendingAuthorization?page&searchTerm&type',
          params: {
              page: { value: 1 },
              searchTerm: { value: '' },
              type: { value: 'all' }
          },
          views: {
              'displayRequests': {
                  templateUrl: require('./DisplayRequests.tpl.html'),
                  controller: 'DisplayRequestsController'
              }
          },
          resolve: {
              getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                  return userAccessRequestService.getPendingAuthorizationUserRequests;
              }],
              requestStatus: function () {
                   return 'pendingAuthorization';
              }
          }
      })
      .state('userAccessRequest.request.postDated', {
          url: '/postDated?page&searchTerm&type',
          params: {
              page: { value: 1 },
              searchTerm: { value: '' },
              type: { value: 'all' }
          },
          views: {
              'displayRequests': {
                  templateUrl: require('./DisplayRequests.tpl.html'),
                  controller: 'DisplayRequestsController'
              }

          },
          resolve: {
              getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                  return userAccessRequestService.getAuthorizedUserRequests;
              }],
              requestStatus: function () {
                   return 'postDated';
              }
          }
      })
     .state('userAccessRequest.request.completed', {
         url: '/completed?page&searchTerm&type',
         params: {
             page: { value: 1 },
             searchTerm: { value: '' },
             type: { value: 'all' }
         },
         views: {
             'displayRequests': {
                 templateUrl: require('./DisplayRequests.tpl.html'),
                 controller: 'DisplayRequestsController'
             }
         },
         resolve: {
             getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                 return userAccessRequestService.getCompletedUserRequests;
             }],
             requestStatus: function () {
                return 'completed';
             }
         }
     })
       .state('userAccessRequest.request.onHold', {
         url: '/onHold?page&searchTerm&type',
         params: {
             page: { value: 1 },
             searchTerm: { value: '' },
             type: { value: 'all' }
         },
         views: {
             'displayRequests': {
                 templateUrl: require('./DisplayRequests.tpl.html'),
                 controller: 'DisplayRequestsController'
             }
         },
         resolve: {
             getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                 return userAccessRequestService.getOnHoldUserRequests;
             }],
             requestStatus: function () {
                 return 'onHold';
             }
         }
     })
     .state('userAccessRequest.request.assignedToMe', {
         url: '/assignedToMe?page&searchTerm',
         params: {
             page: { value: 1 },
             searchTerm: { value: '' }
         },
         views: {
             'displayRequests': {
                 templateUrl: require('./DisplayRequests.tpl.html'),
                 controller: 'DisplayRequestsController'
             }
         },
         resolve: {
             getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                 return userAccessRequestService.getAssignedToMeRequests;
             }],
             requestStatus: function () {
                 return 'assignedToMe';
            }
         }
     })
     .state('userAccessRequest.request.unAssigned', {
         url: '/unAssigned?page&searchTerm',
         params: {
             page: { value: 1 },
             searchTerm: { value: '' }
         },
         views: {
             'displayRequests': {
                 templateUrl: require('./DisplayRequests.tpl.html'),
                 controller: 'DisplayRequestsController'
             }
         },
         resolve: {
             getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                 return userAccessRequestService.getUnAssignedRequests;
             }],
             requestStatus: function () {
                 return 'unAssigned';
             }
         }
     })
    .state('userAccessRequest.request.toProcess', {
        url: '/toProcess?page&searchTerm&custodian&type',
        params: {
            page: { value: 1 },
            searchTerm: { value: '' },
            custodian: { value: '' },
            type: { value: 'all' }
        },
        views: {
            'displayRequests': {
                templateUrl: require('./DisplayRequests.tpl.html'),
                controller: 'DisplayRequestsController'
            }
        },
        resolve: {
            getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                return userAccessRequestService.getToProcessUserRequests;
            }],
            requestStatus: ['$stateParams', function ($stateParams) {
                if ($stateParams.custodian === '') return 'ToProcess';
                return $stateParams.custodian;
            }]
        }
    })

    // Lookup Employee
    .state('userAccessRequest.request.lookupEmployee', {
        url: '/byEmployee',
        views: {
            'lookupEmployee': {
                templateUrl: require('./LookupEmployee.tpl.html'),
                controller: 'LookupEmployeeController'
            }
        }
    })
    .state('userAccessRequest.request.byEmployeeId', {
        url: '/employee/{employeeId:int}?page',
        params: {
            page: { value: 1 },
        },
        views: {
            'displayRequests@userAccessRequest.request': {
                templateUrl: require('./DisplayRequests.tpl.html'),
                controller: 'DisplayRequestsController'
            }
        },
        resolve: {
            getRequests: ['userAccessRequestService', '$stateParams', function (userAccessRequestService) {
                return userAccessRequestService.getUserRequestsByEmployee;
            }],
            requestStatus: function () {
                return 'all';
            }
        }
    });
}]);